<template>
    <div>
      <div class="modal hide fade" id="modalGetProduct" tabindex="0" role="dialog" aria-labelledby="modalGetProduct" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
          <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title">Product List {{ type }}</h4>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
              <div class="row">
                <div class="col-md-12">
                  <div class="table-responsive">
                    <div class="form-inline ml-auto">
                      <button type="button" class="btn btn-hard-primary btn-sm dropdown-toggle" data-toggle="dropdown">
                        <i class="fa fa-filter" aria-hidden="true"></i>
                          Filter
                          <span class="caret"></span>
                      </button>
                      <ul class="dropdown-menu p-2" >
                        <span>Category:</span>
                        <div class="dropdown-divider"></div>
                        <li v-for="ct in getProduct" :key="ct.id">
                          <a href="#" class="small" tabIndex="-1">
                            <input type="checkbox" :value="ct.id" v-model="filterCategory"/>&nbsp; {{ ct.name }}
                          </a>
                        </li>
                      </ul>
                      <div class="button-group">
                        rows:
                        <select id="select-rows" v-model="pageSize" @change="setPageSizeOnChange">
                          <option v-for="r in rowsTable" :key="r.row" :value="r.row">{{ r.row }}</option>
                        </select>
                        <span class="mr-1">
                          Total rows: <b>{{ rowsTotal }}</b>
                        </span>
                      </div>

                      <div class="form-group mx-sm-3 mb-2">
                          <input type="search" placeholder="search..." class="form-control mr-1 input-search" v-model="searchQuery">
                      </div>
                      <span class="mr-1">
                        page:
                        <select v-model="currentPage">
                          <option v-for="p in pageLength" :key="p" :value="p">{{ p }}</option>
                        </select>
                        / {{ pageLength }}
                      </span>
                      <nav aria-label="Page navigation example" class="pull-right">
                          <ul class="pagination">
                              <li class="page-item">
                                  <a class="btn btn-default btn-sm" href="#" @click="prevPage">
                                      <i class="fa fa-angle-left" aria-hidden="true"></i>
                                  </a>
                              </li>
                              <li class="page-item">
                                  <a class="btn btn-default btn-sm" href="#" @click="nextPage">
                                      <i class="fa fa-angle-right" aria-hidden="true"></i>
                                  </a>
                              </li>
                          </ul>
                      </nav>
                    </div>
                    <div v-if="type !== 'unit'">
                      <table class="table table-item mb-0 table-sm table-hover">
                          <thead>
                              <tr>
                                  <th  v-for="t in title" v-bind:key="t.prop" @click="sortTable(t.prop)">
                                      {{ t.name }}
                                      <div class="float-right fa" v-if="t.prop == sortColumn" v-bind:class="ascending ? 'fa-arrow-up' : 'fa-arrow-down'"></div>
                                  </th>
                              </tr>
                          </thead>
                          <tbody>
                            <tr v-if="filterData.length < 1">
                              <td colspan="9" style="text-align: center;"><i><span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> No Data</i></td>
                            </tr>
                              <tr v-for="u in filterData" v-bind:key="u.id" style="cursor: pointer" data-dismiss="modal" @click="select(u.id)">
                                <td><b>{{ u.product_no }}</b></td>
                                <td><b>{{ u.product_sku }}</b></td>
                                <td>{{ u.product_name }}</td>
                                <td>{{ u.product_description }}</td>
                                <td>{{ u.uom_id }}</td>
                                <td>{{ u.price | currency }}</td>
                                <td>
                                  <i class="fa fa-check" aria-hidden="true" style="color: green;" v-show="u.canBarcode"></i>
                                </td>
                                <td>{{ u.total }}</td>
                              </tr>
                          </tbody>
                      </table>
                    </div>
                    <div v-else>
                        <table class="table table-item mb-0 table-sm table-hover">
                          <thead>
                              <tr>
                                  <th  v-for="t in title" v-bind:key="t.prop" @click="sortTable(t.prop)">
                                      {{ t.name }}
                                      <div class="float-right fa" v-if="t.prop == sortColumn" v-bind:class="ascending ? 'fa-arrow-up' : 'fa-arrow-down'"></div>
                                  </th>
                              </tr>
                          </thead>
                          <tbody>
                            <tr v-if="filterDataUnit.length < 1">
                              <td colspan="9" style="text-align: center;"><i><span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> No Data</i></td>
                            </tr>
                              <tr v-for="u in filterDataUnit" v-bind:key="u.id" style="cursor: pointer" data-dismiss="modal" @click="select(u.id)">
                                <td><b>{{ u.product_no }}</b></td>
                                <td><b>{{ u.product_sku }}</b></td>
                                <td>{{ u.product_name }}</td>
                                <td>{{ u.product_description }}</td>
                                <td>{{ u.uom_id }}</td>
                                <td>{{ u.price | currency }}</td>
                                <td>{{ u.category }}</td>
                                <td>
                                  <i class="fa fa-check" aria-hidden="true" style="color: green;" v-show="u.canBarcode"></i>
                                </td>
                                <!-- <td>{{ u.total }}</td> -->
                              </tr>
                          </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
              <!-- <pre>{{ filterData }}</pre> -->
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'PurchasingProductModal',
  props: ['idDetail', 'purchasing', 'type'],
  data () {
    return {
      filterCategory: [],
      searchQuery: '',
      ascending: false,
      sortClick: false,
      sortColumn: '',
      pageSize: 25,
      currentPage: 1,
      title: [{
        name: 'Product No',
        prop: 'product_no'
      }, {
        name: 'Product SKU',
        prop: 'product_sku'
      }, {
        name: 'Name',
        prop: 'product_name'
      }, {
        name: 'Description',
        prop: 'product_description'
      }, {
        name: 'UoM',
        prop: 'uom_id'
      }, {
        name: 'Price',
        prop: 'price'
      }, {
        name: 'Category',
        prop: 'category'
      }],
      selectAll: false,
      selected: [],
      money: {
        decimal: ',',
        thousands: '.',
        prefix: '',
        suffix: '',
        precision: 0,
        masked: true /* doesn't work with directive */
      }
    }
  },
  computed: {
    ...mapState({
      productCategoryList: state => state.products.productCategoryList,
      productByVariant: state => state.products.productByVariant,
      rowsTable: state => state.data.rowsTable
    }),
    getProduct () {
      if (this.type === 'unit') {
        return this.productCategoryList.filter(d => d.name === 'UNIT')
      } else {
        return this.productCategoryList
      }
    },
    getPrice: function () {
      var array = this.productByVariant
      var pl = null
      for (let i = 0; i < array.length; i++) {
        pl = array[i]
      }
      return pl
    },
    pageLength: function () {
      var count = 0
      if (this.searchQuery.length < 0 || this.searchQuery === null) {
        count = this.productByVariant.length
      } else {
        count = this.productByVariant
          .filter(d => {
            for (const name in d) {
              if (d[name] !== null) {
                if (d[name].toString().toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1) {
                  return d
                }
              }
            }
          }).filter(d => {
            if (this.filterCategory.length > 0) {
              for (let i = 0; i < this.filterCategory.length; i++) {
                if (d.category_id === this.filterCategory[i]) {
                  return d
                }
              }
            } else {
              return d
            }
          }).length
      }
      var length = count / this.pageSize

      return Math.ceil(length)
    },
    rowsTotal: function () {
      var count = 0
      if (this.searchQuery.length < 0 || this.searchQuery === null) {
        count = this.productByVariant.length
      } else {
        count = this.productByVariant
          .filter(d => {
            for (const name in d) {
              if (d[name] !== null) {
                if (d[name].toString().toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1) {
                  return d
                }
              }
            }
          }).filter(d => {
            if (this.filterCategory.length > 0) {
              for (let i = 0; i < this.filterCategory.length; i++) {
                if (d.category_id === this.filterCategory[i]) {
                  return d
                }
              }
            } else {
              return d
            }
          }).length
      }
      // console.log(count)
      return count
    },
    filterDataUnit: function () {
      var col = this.sortColumn
      var ascending = this.ascending
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      return this.productByVariant.sort(function (a, b) {
        if (a[col] > b[col]) {
          return ascending ? 1 : -1
        } else if (a[col] < b[col]) {
          return ascending ? -1 : 1
        }
        return 0
      }).filter(d => {
        for (const name in d) {
          if (d[name] !== null) {
            if (d[name].toString().toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1) {
              return d
            }
          }
        }
      }).filter(d => d.category === 'UNIT').filter((row, index) => {
        const start = (this.currentPage - 1) * this.pageSize
        const end = this.currentPage * this.pageSize
        if (index >= start && index < end) return true
      })
    },
    filterData: function () {
      var col = this.sortColumn
      var ascending = this.ascending
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      var dataRow = this.productByVariant.sort(function (a, b) {
        if (a[col] > b[col]) {
          return ascending ? 1 : -1
        } else if (a[col] < b[col]) {
          return ascending ? -1 : 1
        }
        return 0
      }).filter(d => {
        for (const name in d) {
          if (d[name] !== null) {
            if (d[name].toString().toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1) {
              return d
            }
          }
        }
      }).filter(d => {
        if (this.filterCategory.length > 0) {
          for (let i = 0; i < this.filterCategory.length; i++) {
            if (d.category_id === this.filterCategory[i]) {
              return d
            }
          }
        } else {
          return d
        }
      }).filter((row, index) => {
        const start = (this.currentPage - 1) * this.pageSize
        const end = this.currentPage * this.pageSize
        if (index >= start && index < end) return true
      })
      // console.log(dataRow)
      return dataRow
    }
  },
  methods: {
    setPageSizeOnChange: function () {
      this.currentPage = 1
    },
    sortTable: function sortTable (col) {
      this.currentPage = 1
      if (this.sortColumn === col) {
        this.ascending = !this.ascending
      } else {
        this.ascending = true
        this.sortColumn = col
      }
    },
    nextPage: function () {
      if ((this.currentPage * this.pageSize) < this.rowsTotal) {
        // console.log('Hit | ' + this.rowsTotal + ' | ' + this.pageSize + ' | ' + this.currentPage)
        this.currentPage++
      } else {
        // console.log('Loss')
      }
    },
    prevPage: function () {
      if (this.currentPage > 1) {
        // console.log('Hit | ' + this.rowsTotal + ' | ' + this.pageSize + ' | ' + this.currentPage)
        this.currentPage--
      } else {
        // console.log('Loss')
      }
    },
    select: function (id) {
      var product = this.productByVariant.find(d => d.id === id)
      this.$emit('selectProduct', product)
    }
  }
}
</script>
